import { Constants } from "appConstants";

function last<T>(iterable: T[]): T | undefined {
	const { length } = iterable;
	if (length === 0) return undefined;
	return iterable[length - 1];
}

export class FileValidationError extends Error {}

const FileHelper = {
	getFileNameFromUrl(fileUrl: string) {
		const fileName = last(fileUrl.split("/"));
		if (!fileName?.includes("_")) {
			return fileName;
		}
		return fileName?.split("_").slice(1).join("_");
	},

	async validateFile(
		file: File,
		acceptedFormats: string[] | undefined,
		maxByteSize: number | undefined
	): Promise<boolean> {
		const { name: fileName, size } = file;

		const fileExt = last(fileName.split("."));
		if (!fileExt) {
			throw new FileValidationError(Constants.strings.errors.files.noFileExt);
		}

		if (
			acceptedFormats?.length &&
			!acceptedFormats.find(
				(format) => format.toLowerCase() === fileExt.toLowerCase()
			)
		) {
			throw new FileValidationError(
				Constants.strings.errors.files.wrongFileExt(acceptedFormats)
			);
		}

		if (maxByteSize && size > maxByteSize) {
			throw new FileValidationError(
				Constants.strings.errors.files.fileSizeTooBig(maxByteSize)
			);
		}
		return true;
	}
};

export default FileHelper;
